<se-fe-modal #modal [seFeDataSize]="size" [seFeDataActions]="footerOptions">
  <div seFeModalHeader>
    <se-fe-modal-header
      [seFeDataTitle]="title"
      (seFeButtonAction)="modal.close()">
    </se-fe-modal-header>
  </div>
  <div seFeModalContent>
    <ng-template #container>
    </ng-template>
  </div>
</se-fe-modal>
